import type { ActionType } from '@ant-design/pro-components';
import { EditableProTable } from '@ant-design/pro-components';
import { Button, Form, Space } from 'antd';
import React, { useEffect, useRef, useState } from 'react';


import emiter, {
  EVENT_CARRENTAL_EDITTABLE_ADDROW,
  EVENT_CARRENTAL_VEHICLE_OCCUPYDATE_SEARCH_FROM_SEARCH
} from '../../../../events'
interface propsType {
  columns?: any
  title?: any
  value?: any
  onPreview?: any
  formatData?: any
  onUpdateData?: any
}


const defaultData: any[] = [];

const SPEditTable: React.FC<propsType> = (props)=> {

  const { columns, title, value, onPreview, formatData, onUpdateData} = props;

  const actionRef = useRef<ActionType>();
  const [editableKeys, setEditableRowKeys] = useState<React.Key[]>([]);
  const [dataSource, setDataSource] = useState<readonly any[]>(value);
  const [form] = Form.useForm();

  const addRow = (data?: any) => {
    if (data?.service_area_code) {
      delete data.service_area_code;
    }
    if (data && title == '用户还车时') {
      // setDataSource([...dataSource, data])
      actionRef.current?.addEditRecord?.({
        ...data,
        id: (Math.random() * 1000000).toFixed(0),
      });
    } else if(data && title == '用户取车时') {
      return;
    } else {
      actionRef.current?.addEditRecord?.({
        ...formatData({}),
        id: (Math.random() * 1000000).toFixed(0),
    });
    }
  }

  const onUpdateDate = (data: any) => {
    onUpdateData(data, title);
  }

  const handleFencePreview = () => {
    onPreview && onPreview(dataSource.map((item: any) => item.polygon))
  };

  useEffect(() => {
    setDataSource(value);
  }, [value]);

  useEffect(() => {
    emiter.on(EVENT_CARRENTAL_EDITTABLE_ADDROW, addRow)
    return () => {
      emiter.removeAllListeners(EVENT_CARRENTAL_EDITTABLE_ADDROW)
    }
  }, [])

  return (
    <>
      <Space style={{ marginBottom: 12 }}>
        <span>{ title}</span>
        <Button
          type="primary"
          onClick={() => {
            addRow();
          }}
        >
          新建一行
        </Button>
        <Button type="primary" onClick={handleFencePreview}>预览</Button>
      </Space>

      <EditableProTable<any>
        rowKey="id"
        scroll={{
          x: true,
        }}
        actionRef={actionRef}
        maxLength={5}
        // 关闭默认的新建按钮
        recordCreatorProps={false}
        columns={columns}
        request={async () => ({
          data: defaultData,
          total: 3,
          success: true,
        })}
        value={dataSource || []}
        onChange={setDataSource}
        editable={{
          form,
          editableKeys,
          onSave:async (key:any,row:any) => {
            // await waitTime(2000);
            onUpdateDate(row)
            console.log(row);
          },
          onChange: setEditableRowKeys,
          actionRender: (row, config, dom) => [dom.save, dom.cancel],
        }}
      />
    </>
  );
};

export default SPEditTable;
